var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{ref:"adaptiveIframe",class:_vm.iframeClass,style:(_vm.iframeStyle),attrs:{"src":_vm.src,"frameborder":"0","scrolling":"no"},on:{"load":_vm.handleIframeLoad}})
}
var staticRenderFns = []

export { render, staticRenderFns }